import * as yup from 'yup'
import type { Database } from '../types/supabase'
import {
  nullableNumberValidator,
  nullableStringValidator,
  commonFields,
  type InputType,
  type UploadType,
  type EmptyInputType,
  type UploadWithNewReferenceType,
} from './common'
import { KNOWN_MATERIALS } from './constants'

type SeedWeightsInput = Omit<
  InputType<SeedWeightsUpload>,
  'materialweighed_id'
> & { material?: string | null }

type EmptySeedWeightsInput = EmptyInputType<SeedWeightsInput>

type SeedWeightsTable = Database['public']['Tables']['seed_weights']['Insert']

type SeedWeightsUpload = UploadType<SeedWeightsTable>

type SeedWeightsPreUpload = UploadWithNewReferenceType<SeedWeightsUpload>

export type SeedWeightsTypes = {
  upload: SeedWeightsUpload
  withNewReference: SeedWeightsPreUpload
  input: SeedWeightsInput
  emptyInput: EmptySeedWeightsInput
}

export const schema: yup.ObjectSchema<SeedWeightsInput> = yup
  .object({
    ...commonFields,
    material: nullableStringValidator.oneOf(
      KNOWN_MATERIALS,
      `Material must be one of the known materials: ${KNOWN_MATERIALS.join(
        ', ',
      )}`,
    ),
    precision: nullableStringValidator,
    serialnum: nullableStringValidator,
    cultivar: nullableStringValidator,
    notes: nullableStringValidator,
    thousandseedweight: nullableNumberValidator,
  })
  .test(
    'reference-id-or-new-reference-exists',
    'Reference ID or new reference must be provided',
    function (value) {
      if (
        value.reference_id ??
        (value.new_reference_citation && value.new_reference_description)
      ) {
        return true
      }
      return false
    },
  )

export const transform = (
  data: Partial<SeedWeightsInput>,
): Partial<SeedWeightsPreUpload> => {
  const { material, ...rest } = data

  const materialweighed_id = material
    ? KNOWN_MATERIALS.findIndex((m) => m === material) + 1
    : null

  return {
    ...rest,
    materialweighed_id,
  }
}
